import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import {
  getLastOrderId,
  getLastRestaurantId,
} from '@/entities/order/lib/orderStorage';
import { ORDER_QUERY_PARAMS } from '@/shared/constants/orderConstants';
import { ROUTES } from '@/shared/constants/routes';

export default function PaymentSuccessRedirect() {
  const navigate = useNavigate();

  useEffect(() => {
    const restaurantId = getLastRestaurantId();
    const orderId = getLastOrderId();


    if (!restaurantId || !orderId) {
      navigate(ROUTES.home(), { replace: true });
      return;
    }

    navigate(
      `${ROUTES.restaurant(restaurantId)}?${ORDER_QUERY_PARAMS.paymentSuccess}=1&${ORDER_QUERY_PARAMS.orderId}=${orderId}`,
      { replace: true }
    );
  }, [navigate]);

  return null;
}
